<!-- 报表 销售退货单-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="项目点：" v-if="activeName == 'groupMealCustomer'">
            <el-select size="medium" filterable v-model="searchForm.PROJECT_ID" placeholder="请选择" clearable>
              <el-option v-for="item in projects" :key="item.PROJECT_ID" :label="item.PROJECT_NAME" :value="item.PROJECT_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="退货日期：">
            <el-date-picker size="medium" v-model="searchForm.START_END" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" clearable :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单日期：">
            <el-date-picker size="medium" v-model="searchForm.START_END_ORDER" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" clearable :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="操作日期：">
            <el-date-picker size="medium" v-model="searchForm.OPERATE_DATE" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" clearable :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单类型：" v-if="activeName == 'groupMealCustomer'">
            <el-select size="medium" filterable v-model="searchForm.CHECKRETURNSTATUS" placeholder="请选择" clearable>
              <el-option v-for="item in checkReturnStatus" :key="item.value" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商客户：" v-else>
            <el-select size="medium" filterable v-model="searchForm.GYS" placeholder="请选择" @change="chanegFistType">
              <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态：" v-if="activeName != 'groupMealCustomer'">
            <el-select size="medium" filterable v-model="searchForm.CHECKRETURNSTATUS" placeholder="请选择" clearable>
              <el-option v-for="item in supplierCheckReturnStatus" :key="item.value" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="handleSearch()">筛选</el-button>
            <el-button size="medium" type="primary" plain class="btn" @click="$_exportForm">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-tabs type="border-card" @tab-click="handleTabClick" v-model="activeName">
        <el-tab-pane label="团餐客户" name="groupMealCustomer">
          <el-col>
            <el-table :data="newOrderListData" max-height="520" stripe border>
              <el-table-column label="序号" type="index" width="50px"></el-table-column>
              <el-table-column label="订单编号" prop="ORDER_CODE" min-width="100px"></el-table-column>
              <el-table-column label="退货日期" prop="RETURN_DATE" min-width="100px"></el-table-column>
              <el-table-column label="操作日期" prop="OPERATE_DATE" min-width="100px"></el-table-column>
              <el-table-column label="客户名称" prop="TC_NAME" min-width="100px"></el-table-column>
              <el-table-column label="项目点" prop="PROJECT_NAME"></el-table-column>
              <el-table-column label="档口" prop="DK_NAME"></el-table-column>
              <el-table-column label="状态" prop="HAVE_RETURN">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.HAVE_RETURN === 1">已退库</el-tag>
                  <el-tag v-else>未退库</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="openreturnDetail(scope.row)" type="text">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total,prev, pager, next, jumper" :total="totalCount">
            </el-pagination>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="供应商客户" name="supplierCustomer">
          <el-col>
            <el-table :data="supplierCusAllData" max-height="520" stripe border>
              <el-table-column label="序号" type="index" width="50px"></el-table-column>
              <el-table-column label="订单编号" prop="RETURN_ORDER_CODE" min-width="100px"></el-table-column>
              <el-table-column label="退货日期" prop="RETURN_DAY" min-width="100px"></el-table-column>
              <el-table-column label="供应商名称" prop="GYS_NAME" min-width="100px"></el-table-column>
              <!-- <el-table-column label="操作时间" prop="CREATE_TIME"></el-table-column> -->
              <el-table-column label="状态" prop="HAVE_RETURN">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.HAS_RETURNED === 1">已退库</el-tag>
                  <el-tag v-else>未退库</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="openDetail(scope.row)" type="text"> {{ scope.row.HAVE_RETURN === 1 ? '查看' : '退库' }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleSupplierChange" :current-page.sync="currentSupplierPage" :page-size="supplierPageSize"
              layout="total,prev, pager, next, jumper" :total="totalCount">
            </el-pagination>
          </el-col>
        </el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>
<script>
import { haveDSXMDFun } from 'api/sellOrder';
import { exportReturnForm } from 'api/returnWare';
import { supplierCusFun } from 'api/customerManage';
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      // 分页
      currentOrderFlag: 0,
      total_count: 0,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      activeName: 'groupMealCustomer',
      // 搜索框内容
      searchForm: {
        GYS: '',
        START_END: [],
        START_END_ORDER: [],
        OPERATE_DATE: [date(new Date(), '%F'), date(new Date(), '%F')],
      },
      currentSupplierPage: 1,
      supplierPageSize: 10,
      // 下拉框数据渲染
      projects: [],
      companys: [],
      supplierCusAllData: [],
      // 日期的选择范围
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      GYS_IDF: '',
      // 渲染列表的数据
      newOrderListData: [],
      checkReturnStatus: [
        {
          NAME: '未退库',
          ID: 1,
        },
        {
          NAME: '已退库',
          ID: 2,
        },
      ],
      supplierCheckReturnStatus: [
        {
          NAME: '未退库',
          ID: '0',
        },
        {
          NAME: '已退库',
          ID: '1',
        },
      ],
    };
  },
  methods: {
    handleSearch() {
      if ((this.searchForm.START_END == null || this.searchForm.START_END.length == 0) && (this.searchForm.OPERATE_DATE == null || this.searchForm.OPERATE_DATE.length == 0) && (this.searchForm.START_END_ORDER == null || this.searchForm.START_END_ORDER.length == 0)) {
        this.$message.show({ text: '请至少选择订单日期或退货日期或操作日期中的一项', type: 'warning' });
        return;
      }
      if (this.currentOrderFlag == 0) {
        this.currentPage = 1;
        // 团餐客户订单列表
        this.queryList();
      } else if (this.currentOrderFlag == 1) {
        this.currentSupplierPage = 1;
        // 供应商客户订单列表
        this.querysupplierList();
      }
    },
    // 拉取数据
    queryList() {
      const params = {
        SERVICE_ID: '10028',
        OTYPE: 20,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.START_END_ORDER != null && this.searchForm.START_END_ORDER.length == 2) {
        params.ORDER_START_DAY = this.searchForm.START_END_ORDER[0];
        params.ORDER_END_DAY = this.searchForm.START_END_ORDER[1];
      }
      if (this.searchForm.OPERATE_DATE != null && this.searchForm.OPERATE_DATE.length == 2) {
        params.OPERATE_START_DAY = this.searchForm.OPERATE_DATE[0];
        params.OPERATE_END_DAY = this.searchForm.OPERATE_DATE[1];
      }
      if (this.searchForm.START_END != null && this.searchForm.START_END.length == 2) {
        params.START_DAY = this.searchForm.START_END[0];
        params.END_DAY = this.searchForm.START_END[1];
      }
      if (this.searchForm.CHECKRETURNSTATUS) {
        params.FILTER_RETURN = this.searchForm.CHECKRETURNSTATUS;
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.newOrderListData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.newOrderListData.forEach((element) => { // tableData你的数据源
            this.status = element.ORDER_STATUS;
          });
          this.$store.dispatch('设置销售退货单存储数据', {
            ACTIVE_NAME: this.activeName,
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
            TOTAL_COUNT: this.totalCount,
          });
        } else {
          this.newOrderListData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      });
    },
    handleTabClick(tab, event) {
      this.currentOrderFlag = Number(tab.index);
      sessionStorage.setItem('returnGoodsTabActiveName', this.activeName);
      if (this.currentOrderFlag == 0) {
        this.currentPage = 1;
        // 团餐客户订单列表
        this.queryList();
      } else if (this.currentOrderFlag == 1) {
        this.currentSupplierPage = 1;
        // 供应商客户订单列表
        this.querysupplierList();
      }
    },
    handleSupplierChange(e) {
      this.currentSupplierPage = e;
      this.querysupplierList();
    },
    chanegFistType(e) {
      this.GYS_IDF = e;
      this.querysupplierList(e);
    },
    querysupplierList(index) {
      const params = {
        SERVICE_ID: '10031',
        // OTYPE: 51,
        OTYPE: 93,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: this.currentSupplierPage - 1,
        PAGESIZE: this.supplierPageSize,
      };
      if (this.searchForm.START_END != null && this.searchForm.START_END.length == 2) {
        params.START_DAY = this.searchForm.START_END[0];
        params.END_DAY = this.searchForm.START_END[1];
      }
      if (this.searchForm.START_END_ORDER != null && this.searchForm.START_END_ORDER.length == 2) {
        params.ORDER_START_DAY = this.searchForm.START_END_ORDER[0];
        params.ORDER_END_DAY = this.searchForm.START_END_ORDER[1];
      }
      if (this.searchForm.OPERATE_DATE != null && this.searchForm.OPERATE_DATE.length == 2) {
        params.OPERATE_START_DAY = this.searchForm.OPERATE_DATE[0];
        params.OPERATE_END_DAY = this.searchForm.OPERATE_DATE[1];
      }
      if (this.searchForm.GYS) {
        params.GYS_ID = this.searchForm.GYS;
      }
      if (this.searchForm.CHECKRETURNSTATUS) {
        params.HAS_RETURNED = Number(this.searchForm.CHECKRETURNSTATUS);
      }
      http.post(params)
        .then((result) => {
          if (result.TOTAL_COUNT !== 0) {
            this.supplierCusAllData = result.LIST;
            this.totalCount = result.TOTAL_COUNT;
          } else {
            this.supplierCusAllData = [];
            this.totalCount = result.TOTAL_COUNT;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
          this.$store.dispatch('设置销售退货单存储数据', {
            ACTIVE_NAME: this.activeName,
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
            TOTAL_COUNT: this.totalCount,
          });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // -------------------------------------选择客户
    queryCustomer() {
      const params = {};
      supplierCusFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.companys = result[0].list;
            // this.searchForm.GYS = result[0].list[0].SUPPLIER_ID
          } else {
            this.companys = [];
            this.customers = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    openDetail(row) {
      this.$router.push({ path: `/SupplierCusSalesReturnProductDetail/${row.SALES_RETURN_ID}`, params: { srid: row.SALES_RETURN_ID } });
      sessionStorage.setItem('returnMess', JSON.stringify(row));
    },
    // 获取项目点
    queryProjects() {
      haveDSXMDFun().then((result) => {
        this.projects = result.length > 0 ? result[0].project : [];
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 查看，跳转
    openreturnDetail(row) {
      this.$router.push({ path: '/returnGoodsDetail/detail' });
      sessionStorage.setItem('ORDER_ID', row.ID);
    },
    // 导出
    $_exportForm() {
      const params = {
      };
      if (this.searchForm.START_END != null && this.searchForm.START_END.length == 2) {
        params.START_DAY = this.searchForm.START_END[0];
        params.END_DAY = this.searchForm.START_END[1];
      }
      if (this.searchForm.START_END_ORDER != null && this.searchForm.START_END_ORDER.length == 2) {
        params.ORDER_START_DAY = this.searchForm.START_END_ORDER[0];
        params.ORDER_END_DAY = this.searchForm.START_END_ORDER[1];
      }
      if (this.searchForm.OPERATE_DATE != null && this.searchForm.OPERATE_DATE.length == 2) {
        params.OPERATE_START_DAY = this.searchForm.OPERATE_DATE[0];
        params.OPERATE_END_DAY = this.searchForm.OPERATE_DATE[1];
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      exportReturnForm(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '暂无数据', type: 'error' });
        } else {
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 分页按钮
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryList();
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.销售退货单存储数据) {
      this.searchForm = this.销售退货单存储数据.CONDITION;
      this.currentPage = this.销售退货单存储数据.CURRENT_PAGE;
      this.activeName = this.销售退货单存储数据.ACTIVE_NAME;
    } else {
      this.currentPage = 1;
    }
    this.queryProjects();
    this.queryCustomer();
    if (this.activeName == 'groupMealCustomer') {
      this.queryList();
    } else {
      this.querysupplierList();
    }
  },
  computed: {
    // 上一次的搜索结果和条件
    销售退货单存储数据() {
      return this.$store.state.销售退货单存储数据;
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tableManage/returnGoods.vue